// TODO move to Clarity in Jira WORHTY-11788

import React from 'react';
import { HelperText, Regular, MediumPrimaryButton } from '@worthy-npm/clarity';
import { isMobile } from "../../helpers/ApplicationHelper";
import UserActions from "lib/userActions";

class ItemLinkSticky extends React.Component {
    constructor(props) {
        super(props)

        this.innerWidth = 0
    }

    componentDidMount(){
        UserActions.lightTrendsPage('Sell ring sticky presented', this.props.itemId, this.props.version)
        this.innerWidth = window.innerWidth
    }


    render() {
        const mobile = isMobile()
        const {itemId, version, text} = this.props

        const style = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: mobile? "7px 12px" : "12px 18px",
            background: "#FFFFFF",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.08)",
            borderRadius: "4px",
            border: "1px solid #F2F2F2"
        }

        const cssOverride = {
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: this.innerWidth - 140 + "px"
        }


        return (
            <div className={'main-item-sticky-wrapper'}>
            <div style={style}>
                <div style={{display:"flex", flexDirection: 'column'}}>
                    <HelperText text="Your ring:"/>
                    <Regular bold={true} overrideCSS={cssOverride} text={text}/>
                </div>
                <div data-automation='recent-deals-sticky-cta'>
                    <MediumPrimaryButton text={mobile? "Sell": "Sell Your Ring"} disableAnimation={mobile} click={(stopAnimation)=>{
                        stopAnimation()
                        window.location.pathname = `/item/${itemId}`
                        UserActions.lightTrendsPage('Sell ring sticky clicked', itemId, version)
                    }}/>
                </div>
            </div>
            </div>
        )
    }
}
export default ItemLinkSticky;